module.exports = __webpack_public_path__ + "img/icon_capability01.867b8737.png";